import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { NS } from '@/screens/Service/ducks/reducer';
import {
  getDraftAnnouncements,
  deleteDraftAnnouncement,
  updateCrumbs
} from '@/screens/Service/ducks/actions';

import { DraftPages } from '../../components/DraftPages';

export const DraftAnnouncements = props => {
  const { updateCrumbs } = props;
  useEffect(() => {
    updateCrumbs([
      {
        label: 'Drafts Announcements'
      }
    ]);
  }, []);
  return <DraftPages {...props} />;
};

const mapStateToProps = state => ({
  service: state.getIn([NS, 'service']),
  drafts: state.getIn([NS, 'draftAnnouncements']),
  pending: state.getIn([NS, 'pending', 'draftAnnouncements'])
});
const mapDispatchToProps = dispatch => ({
  getDrafts: handle => dispatch(getDraftAnnouncements(handle)),
  deleteDraft: id => dispatch(deleteDraftAnnouncement(id)),
  updateCrumbs: crumbs => dispatch(updateCrumbs(crumbs))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DraftAnnouncements);
